/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';

import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core';
import SaveIcon from '@material-ui/icons/Save';
import Button from '../../common/Button';
import AlertDialog from '../../common/alertDialog/AlertDialog';
import useContactForm from '../../addressBook/contact/useContactForm';
import { PartyStatus } from '../../addressBook/PartyStatus';
import DuplicateContactDialog from '../../addressBook/duplicate/DuplicateContactDialog';

const useStyles = makeStyles(() => ({
  addContactButtonContainer: {
    display: 'flex',
    flex: '1',
    justifyContent: 'flex-start',
  },
}));

export default function AddContactButtonField({ formData, onConfirm, element, id }) {
  const classes = useStyles();
  const { t } = useTranslation();
  const {
    showSuccessDialog,
    setShowSuccessDialog,
    saveContactAndManageDuplicates,
    mapFormToContact,
    partyResult,
    setPartyResult,
    resolveAllDuplicates,
    onCancel,
    resultMessage,
  } = useContactForm();

  const onClick = async () => {
    const saveContact = async () => {
      const contactToSave = mapFormToContact(formData);
      saveContactAndManageDuplicates(contactToSave);
    };
    onConfirm(element, saveContact);
  };

  const onClose = () => {
    setShowSuccessDialog(false);
    setPartyResult(null);
  };

  return (
    <>
      <div className={classes.addContactButtonContainer}>
        <Button onClick={onClick} variant="text" color="primary" startIcon={<SaveIcon />} id={id}>
          {t('actions.save.contact.book')}
        </Button>
      </div>
      {showSuccessDialog && (
        <AlertDialog
          isOpen={showSuccessDialog}
          title={t('contact.title')}
          message={t(resultMessage)}
          handleConfirmButton={onClose}
          confirmButtonMessage="actions.ok"
        />
      )}
      {partyResult?.status === PartyStatus.DUPLICATED && (
        <DuplicateContactDialog
          partyResult={partyResult}
          onAllDuplicatesResolved={resolveAllDuplicates}
          onCancelSave={onCancel}
        />
      )}
    </>
  );
}
